import APIController from '../core-api-controller';

export const fetchDashboardDataApi = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/dashboards${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};
